import { render, staticRenderFns } from "./depositDetail.vue?vue&type=template&id=94df104a&scoped=true"
import script from "./depositDetail.vue?vue&type=script&lang=js"
export * from "./depositDetail.vue?vue&type=script&lang=js"
import style0 from "./depositDetail.vue?vue&type=style&index=0&id=94df104a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94df104a",
  null
  
)

export default component.exports